import { FitToViewBaseCapabilityCoordinator } from './fit-to-view-base-capability-coordinator';

export class FitToViewModelCapabilityCoordinator extends FitToViewBaseCapabilityCoordinator {
  public async fitToView(modelId: string): Promise<void> {
    const promises = this.getEligibleViewers().map((viewer) =>
      viewer.camera.fitToView(modelId)
    );

    await Promise.all(promises);
  }

  public cleanup(): Promise<void> {
    return Promise.resolve();
  }
}
